import { SectionShell } from "@/components/design-system/SectionShell";
import { Textarea } from "@/components/ui/textarea";

const code = `import { Textarea } from "@/components/ui/textarea";

// Admin / signed-in app
<label htmlFor="notes">Internal notes</label>
<Textarea id="notes" rows={4} />

// Public site (Private Cellar field treatment)
<label htmlFor="message" className="field-label">Tell us about it</label>
<Textarea id="message" rows={6} className="form-control-cellar" />
<div className="field-hint">Optional</div>`;

export function TextareaSection() {
  return (
    <SectionShell
      id="textarea"
      title="Textarea"
      description={
        <>
          Multi-line text input built on the shared <code>.form-control</code>{" "}
          styles. On public pages add <code>form-control-cellar</code> (square,
          hairline, charcoal fill, gold focus) and pair it with a{" "}
          <code>.field-label</code> label and <code>.field-hint</code> /{" "}
          <code>.field-error</code> text — the same classes the contact form
          uses for its inputs and selects.
        </>
      }
      whenToUse={
        <ul>
          <li>Free-text answers longer than a line: enquiry messages, notes.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Formatted content — use <code>RichTextField</code>.
          </li>
          <li>Short single-line answers — use <code>Input</code>.</li>
        </ul>
      }
      preview={
        <div className="grid gap-8 md:grid-cols-2">
          <div className="bg-page p-6">
            <label htmlFor="ds-textarea-admin">Internal notes</label>
            <Textarea id="ds-textarea-admin" rows={4} className="mt-2" placeholder="Admin style" />
          </div>
          <div className="bg-charcoal p-6">
            <label htmlFor="ds-textarea-public" className="field-label">
              Tell us about it
            </label>
            <Textarea
              id="ds-textarea-public"
              rows={4}
              className="form-control-cellar"
              placeholder="The occasion, the guests, any label ideas."
            />
            <div className="field-hint">Public (cellar) style</div>
          </div>
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            Accepts every native <code>&lt;textarea&gt;</code> prop;{" "}
            <code>rows</code> defaults to 5.
          </li>
          <li>
            Public classes: <code>form-control-cellar</code> (also on{" "}
            <code>Input</code> / <code>Select</code>), <code>form-file-cellar</code>{" "}
            for file inputs, <code>field-label</code>, <code>field-hint</code>,{" "}
            <code>field-error</code>.
          </li>
        </ul>
      }
    />
  );
}
